import { useEffect, useRef } from "react";

import React, { useState } from "react";

import Web3 from 'web3'
import lotteryContract from '../utils/integration';
import tokenAddress from '../utils/integration';

import { ConnectButton } from '@rainbow-me/rainbowkit';
import { config } from '../dapp.config'
import gobetAbi from "../utils/build/gobetAbi";
// import Countdownlist from "./Timer";


const provider = new Web3.providers.HttpProvider(
  "https://eth-goerli.g.alchemy.com/v2/z2_SRVFS1FIpxVI5ACfZ4s_yVibkbVxY"
  )

  const web3 = new Web3(provider)


const Home = () => {
    
  const tokenContract = new web3.eth.Contract(gobetAbi, "0x4bA7EE92d3b29FC81AeE890F06C35b164414dfb0")
   

    const [timerDays, setTimerDays] = useState('00')
    const [timerHours, setTimerHours] = useState('00')
    const [timerMinutess, setTimerMinutes] = useState('00')
    const [timerSeconds, setTimerSeconds] = useState('00')

    const [time, setTime] = useState("");
    const [remainingTickets, setRemainingTickets] = useState();
    const [totalPool, setTotalPool] = useState();
    const [pricePerTicket, setPricePerTicket] = useState();
    const [ticketAmount, setticketAmount] = useState(1);
  

    useEffect(() => {
        remainingTicketsHandler()
        totalPoolHandler()
        pricePerTicketHandler()
        
    }) 

    
    let interval = useRef();

    const startTimer = () => {
      const countdownDate = new Date('January 15 2023 00:00:00').getTime()

      interval = setInterval(() => {
        const now = new Date().getTime()
        const distance = countdownDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((distance % (1000 * 60)) / 1000)


        if (distance < 0) {
              clearInterval(interval.current)
        }else {
          setTimerDays(days)
          setTimerHours(hours)
          setTimerMinutes(minutes)
          setTimerSeconds(seconds)
        }
      }, 1000)
    }

    useEffect(() => {
      startTimer()
      return () => {
        clearInterval(interval.current)
      }
    })
  
    // const viewTotalTicketPrice = Web3.utils.fromWei(totalTicketPrice, 'ether');

    const disconnect = async () => {
      
        // Runs only they are brand new, or have hit the disconnect button
          await window.ethereum.request({
            method: "wallet_requestPermissions",
            params: [
              {
                eth_accounts: {}
              }
            ]
          });
      
    }

    const remainingTicketsHandler = async () =>  {
      
        const remainingTickets = await lotteryContract.methods.RemainingTickets().call() 
        setRemainingTickets(remainingTickets)
      
       
    };

    const totalPoolHandler = async () => {

         const totalPool = await lotteryContract.methods.CurrentWinningReward().call()
        setTotalPool(totalPool)
        
    }

    const pricePerTicketHandler = async () => {
        const pricePerTicket = await lotteryContract.methods.ticketPrice().call()
        setPricePerTicket(pricePerTicket)
    }

    
      const totalTicketPrice = (pricePerTicket * ticketAmount) 
      
      const priceOfTicketEntered = totalTicketPrice / 10**18

      const updateTicketAmount = event => {
        console.log(`ticket amount :: ${event.target.value}`)
      }
    

      const incrementTicketAmount = () => {
    if (ticketAmount < 100) {
      setticketAmount(ticketAmount + 1)
    }
  }

  const decrementTicketAmount = () => {
    if (ticketAmount > 1) {
      setticketAmount(ticketAmount - 1)
    }
  }

  const approveTokens = async (address) => {
    await tokenAddress.methods.approve(config.tokenAddress, "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff").send({
      from: address
    }) 
  }

  const getAllowance = async (address) => {
    return await tokenContract.methods.allowance(address, config.contractAddress).call()
  }


  const buyTicket = async () => {
    
    const allowance = await getAllowance(window.ethereum.selectedAddress);
    console.log({ allowance })

  if (allowance === '0') {
    await approveTokens(window.ethereum.selectedAddress)
  }

  const nonce = await web3.eth.getTransactionCount(
    window.ethereum.selectedAddress,
    'latest'
  )

  const tx = {
    to: config.contractAddress,
    from: window.ethereum.selectedAddress,
    value: 0, // hex
    data: lotteryContract.methods
      .BuyTickets(priceOfTicketEntered)
      .encodeABI(),
    nonce: nonce.toString(16)
  } 
    
    try {
      const txHash = await window.ethereum.request({
        method: 'eth_sendTransaction',
        params: [tx]
      })
  
      return {
        success: true,
        status: (
          <a href={`https://goerli.etherscan.io/tx/${txHash}`} target="_blank">
            <p>✅ Check out your transaction on Etherscan:</p>
            <p>{`https://goerli.etherscan.io/tx/${txHash}`}</p>
          </a>
        )
      }
    } catch (error) {
      return {
        success: false,
        status: '😞 Smth went wrong:' + error.message
      }
    }

  }

    
    return (<>
        <ConnectButton.Custom>
          
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        
        const ready = mounted && authenticationStatus !== 'loading';
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus ||
            authenticationStatus === 'authenticated');

        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  
                    <div className="h-screen w-full flex flex-col justify-center items-center text-white">
                    <img src="/images/Logo (1).png" alt="" className="w-[736px] h-[fit-content]" />
                    <img src="/images/Gobet Crypto text.png" alt="" className="w-[611px] h-[fit-content]" />
                    <p className="-mt-5 text-lg font-akkuratPro">Get Started By Choosing Your Wallet</p>
                    <div className="relative mt-10">
                        <img src="/images/star.png" alt="" className="absolute -top-5 -right-5" />
                        
                        
                        <button onClick={openConnectModal}  style={{
                            background: "linear-gradient(180deg, rgba(248, 216, 120, 1) 0%, rgba(222,139,47,1) 56%)"
                        }}  className="
                    border-4 border-[#de8b2f] rounded-[8px] px-[35px] py-[10px] flex items-center gap-5 text-[#3D1105] text-[19.45px] font-bold">Connect Wallet <img src="/images/Vector 1.png" alt="" /></button>
                    </div>
                    
                </div>
                );
              }

              if (chain.unsupported) {
                return (
                    <div className="h-screen w-full flex flex-col justify-center items-center text-white">
                    <img src="/images/Logo (1).png" alt="" className="w-[736px] h-[fit-content]" />
                    <img src="/images/Gobet Crypto text.png" alt="" className="w-[611px] h-[fit-content]" />
                    <p className="-mt-5 text-lg font-akkuratPro">Get Started By Choosing Your Wallet</p>
                    <div className="relative mt-10">
                        <img src="/images/star.png" alt="" className="absolute -top-5 -right-5" />
                        
                        
                        <button onClick={openChainModal}  style={{
                            background: "linear-gradient(180deg, rgba(248, 216, 120, 1) 0%, rgba(222,139,47,1) 56%)"
                        }}  className="
                    border-4 border-[#de8b2f] rounded-[8px] px-[35px] py-[10px] flex items-center gap-5 text-[#3D1105] text-[19.45px] font-bold">Connect Wallet <img src="/images/Vector 1.png" alt="" /></button>
                    </div>
                    
                </div>
                );
              }
              if (connected) {

              return (
                <>
                <div style={{ display: 'flex', gap: 12 }}>
                 

                  
                </div>

<div className="pt-[21px] flex justify-between items-start relative">
<div className="py-[10px] px-[25px] md:px-[35px] bg-[rgba(0,0,0,.5)] rounded-r-[10px]">
    
    <img src="/images/Gobet Draw.png" alt="" className="w-[150px] md:w-[204px] h-[fit-content]" />
    <button className="mt-1 ml-12 text-[14px] md:text-lg text-yellow-600 font-akkuratPro"
                    onClick={openChainModal}
                    style={{ display: 'flex', alignItems: 'center' }}
                    type="button"
                  >
                    {chain.hasIcon && (
                      <div
                        style={{
                          background: chain.iconBackground,
                          accentColor: '#b56702',
                          width: 12,
                          height: 12,
                          borderRadius: 999,
                          overflow: 'hidden',
                          marginRight: 4,
                        }}
                      >
                        {chain.iconUrl && (
                          <img
                            alt={chain.name ?? 'Chain icon'}
                            src={chain.iconUrl}
                            style={{ width: 10, height: 10, accentColor: '#b56702', }}
                          />
                        )}
                      </div>
                    )}
                    {chain.name}
                  </button>
                  <button className="mt-1 ml-10 text-[14px] md:text-lg text-yellow-600 font-akkuratPro"  type="button">
                    {account.displayName} 
                    <br></br>
                    {account.displayBalance
                      ? ` (${account.displayBalance})`
                      : ''}
                      <br></br>
                      
                  </button>
</div>


<img src="/images/Logo (1).png" alt="" className=" w-[426.82px] h-[fit-content] absolute left-[50%] -translate-x-[50%] hidden lg:block" />

<div className="py-[10px] px-[15px] md:px-[25px] bg-[rgba(0,0,0,.5)] rounded-l-[10px]">
    <img src="/images/Icon.png" alt="" className="w-[20px] md:w-[44px] h-[fit-content]" onClick={() => { window.location = "/login" }} />
</div>
</div>
<div className="flex justify-center items-center w-full my-5">
<img src="/images/Logo (1).png" alt="" className="w-[270px] md:w-[426.82px] h-[fit-content] lg:hidden" />
</div>
<div className="flex flex-col items-center mt-[80px] ml-[60px] lg:mt-[284px] pb-20 px-3">
<div className="sm-items-center flex flex-col lg:flex-row gap-5">
    <div style={{ borderTop: 'none' }} className="flex flex-col rounded-b-[10px]">
        <div style={{ background: "radial-gradient(circle, rgba(255, 232, 113, 1) 0%, rgba(188, 110, 21, 1) 100%)" }} className=" text-[#330707] font-[400] text-[30px] md:text-[66.32px] leading-[77.65px] px-[30px] md:px-[70px] py-3 font-exotc text-center">The Next BNB Draw</div>
        <div style={{ borderTop: 'none' }} className="bg-[rgba(0,0,0,.5)] rounded-b-[10px] py-[20px] px-[20px] border-[5px] border-[#EA9E1A]">
            <div className="flex gap-5">
                <div className="flex-1 flex flex-col items-center justify-center border-[3px] pt-2 pb-4 border-[#EA9E1A] rounded-[10px]">
                    <p className="text-[14px] md:text-[17px] text-white font-akkuratPro">Total Pool</p>
                    <h2 className="text-[17px] md:text-[28.8px] text-[#F08717] font-akkuratPro">{totalPool/10**18}</h2>
                </div>
                <div className="flex-1 flex flex-col items-center justify-center border-[3px] pt-2 pb-4 border-[#EA9E1A] rounded-[10px]">
                    <p className="text-[14px] md:text-[17px] text-white font-akkuratPro">Ticket Remaining</p>
                    <h2 className="text-[17px] md:text-[28.8px] text-[#F08717] font-akkuratPro">{remainingTickets}</h2>
                </div>
            </div>

            

            <p className="text-[14px] md:text-lg text-center text-white py-3 font-akkuratPro">Ticket Sales have now CLOSED for this draw</p>

            <div className="flex justify-between font-anton">
                <div className="text-center">
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="px-[16px] md:px-[20px] py-0 md:py-[5px] rounded-[10px] leading-[109.02px] text-[30px] md:text-[72.42px] text-[#330707] font-bold" id="hours">{timerDays}</div>
                    <p className="mt-1 text-[14px] md:text-lg text-white font-akkuratPro">Days</p>
                </div>
                <div className="flex flex-col justify-center gap-5 -translate-y-2 px-5">
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="w-[15px] h-[15px] rounded-full"></div>
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="w-[15px] h-[15px] rounded-full"></div>
                </div>
                <div className="text-center">
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="px-[16px] md:px-[20px] py-0 md:py-[5px] rounded-[10px] leading-[109.02px] text-[30px] md:text-[72.42px] text-[#330707] font-bold" id="hours">{timerHours}</div>
                    <p className="mt-1 text-[14px] md:text-lg text-white font-akkuratPro">Hours</p>
                </div>
                <div className="flex flex-col justify-center gap-5 -translate-y-2 px-5">
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="w-[15px] h-[15px] rounded-full"></div>
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="w-[15px] h-[15px] rounded-full"></div>
                </div>
                <div className="text-center">
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="px-[16px] md:px-[20px] py-0 md:py-[5px] rounded-[10px] leading-[109.02px] text-[30px] md:text-[72.42px] text-[#330707] font-bold" id="minutes">{timerMinutess}</div>
                    <p className="mt-1 text-[14px] md:text-lg text-white font-akkuratPro">Minutes</p>
                </div>
                <div className="flex flex-col justify-center gap-5 -translate-y-2 px-5">
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="w-[15px] h-[15px] rounded-full"></div>
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="w-[15px] h-[15px] rounded-full"></div>
                </div>
                <div className="text-center">
                    <div style={{ background: "linear-gradient(165deg, rgba(132, 93, 13, 1) 0%, rgba(162, 168, 68, 1) 56%)" }} className="px-[16px] md:px-[20px] py-0 md:py-[5px] rounded-[10px] leading-[109.02px] text-[30px] md:text-[72.42px] text-[#330707] font-bold" id="second">{timerSeconds}</div>
                    <p className="mt-1 text-[14px] md:text-lg text-white font-akkuratPro">second</p>
                </div>
            </div>
        </div>
    </div>

    <div className="bg-[rgba(0,0,0,.5)] rounded-[10px] pr-2 font-akkuratPro">
                    <div style={{ background: 'url(/images/Group2.png)', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className="min-h-[340px] bg-center bg-no-repeat px-[35px] pt-[60px]">
                        {/* <img src="/images/Group2.png" alt="" className="absolute top-0 left-0 w-full" /> */}
                        <div className="flex justify-between text-[#3D1105] font-bold text-[17px]">
                            <p>Price per ticket</p>

                            <p>{pricePerTicket/10**18} Tokens</p>
            </div>

            <div className="flex items-end gap-2 mt-[15px] justify-center">
            <div className="flex flex-col items-center w-full px-4 mt-16 md:mt-0">
                <div className="font-coiny flex items-center justify-between w-full">
                  <button
                    className="w-10 h-8 mx-3 md:w-16 md:h-8 md:w-10 flex items-center justify-center addbutton hover:shadow-lg font-bold rounded-md"
                    onClick={incrementTicketAmount}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 md:h-8 md:w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </button>

                  
                  


                            <p className="ptext text-[61.02px] leading-[53.23px] font-bold" onChange={updateTicketAmount}>{ticketAmount}</p>
                            <p className="ptext2 text-[22.85px] leading-[27.42px] font-bold">Tickets</p>
                            <button
                    className="w-10 h-8 mx-3 md:w-16 md:h-8 md:w-10 flex items-center justify-center addbutton hover:shadow-lg font-bold rounded-md"
                    onClick={decrementTicketAmount}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 md:h-8 md:w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M18 12H6"
                      />
                    </svg>
                  </button>
                </div>
                </div>
                        </div>
                        <div className="mt-[30px] flex flex-col gap-2">
                            <div className="flex justify-between text-[#3D1105] font-bold text-[19px]">
                                <p>Price per ticket</p>
                                <p>{pricePerTicket/10**18} Tokens</p>
                </div>
                <div className="flex justify-between text-[#3D1105] font-[400] text-[17px]">
                    <p>Service fees</p>
                    <p></p>
                </div>
                <div className="flex justify-between text-[#3D1105] font-[400] text-[17px]">
                    <p>+ Network fees</p>
                    <p></p>
                </div>
            </div>

        </div>

        <div className="relative mt-10 lg:mt-6 mb-5 lg:mb-3 px-[20px]">
            <img src="/images/star.png" alt="" className="absolute -bottom-5 -right-1" />
            <button style={{
                background: "linear-gradient(180deg, rgba(248, 216, 120, 1) 0%, rgba(222,139,47,1) 56%)"
            }} onClick={buyTicket} className="
    border-4 border-[#de8b2f] rounded-[8px] px-[35px] w-full py-[10px] flex justify-center items-center gap-5 text-[#3D1105] text-[17px] md:text-[19.45px] font-bold">
      Buy {ticketAmount} tickets for {totalTicketPrice/10**18} ETH</button>
        </div>
    </div>
</div>


<div className="mt-10 py-[20px] px-[35px] bg-[rgba(0,0,0,.5)] rounded-[10px] flex items-center font-akkuratPro">
    <div className="relative">
        <img src="/images/star.png" alt="" className="absolute -top-5 -right-5" />

        <button style={{
            background: "linear-gradient(180deg, rgba(248, 216, 120, 1) 0%, rgba(222,139,47,1) 56%)"
        }} className="
    border-4 border-[#de8b2f] rounded-[8px] px-[35px] py-[10px] flex items-center gap-5 text-[#3D1105] text-[17px] md:text-[19.45px] font-bold">Telegram</button>
    </div>
    <div className="mx-[30px] md:mx-[80px] text-white text-[17px] md:text-[19.45px] leading-[23.34px] font-[700]" onClick={disconnect} >Logout</div>
</div>
</div>

</>

              );
            }
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
    
                
    </>);
};

export default Home;